export default {
  header: 'Nu am putut încărca comanda',
  text: 'Ceva nu a mers bine la pregătirea comenzii. Coșul tău este în siguranță — te rugăm să încerci din nou.',
  retry: 'Încearcă din nou',
  address_header: 'Avem nevoie de adresa ta de livrare',
  address_text: 'Nu putem calcula totalul până nu știm unde livrăm. Coșul tău este în siguranță.',
  address_action: 'Adaugă adresa de livrare',
  back_checkout: 'Înapoi la comanda ta',
  back_basket: 'Înapoi la coșul tău',
};
